export default __webpack_public_path__ + "static/media/test-assignment-zechmann-hero-en.9a5a3327.png";